import React from "react";
import { useState } from "react";
import Booking from "../../pages/Booking"

export default function Calendar() {
    const [ openState, setOpenState ] = useState({
        isOpen: false
    });
    function showBooking() {
        setOpenState( state => ({
            isOpen: !state.isOpen
        }))
    };

    return (
        <section id="calendar">
            <div class="text-block">
               
                <button onClick={()=> showBooking()} className="cta transition">Book a session</button>
                <p>If you have any additional questions regarding our services, our coaches, or anything in between, please email <a href="mailto:eskewconsulting@gmail.com">eskewconsulting@gmail.com</a>.</p>

            </div>
            <Booking className={openState.isOpen ? "book-now" : ""}/>
            
        </section>
    )
}